import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CUST, CUST_ANIM, CUST_GRADIENTS } from '../../../../theme/customizer-tokens';

/* ── Desktop ─────────────────────────────────────────────────────────────── */

export const DesktopBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
`;

/** 2×2 grid of generated-logo cards. Fills the available height (the page doesn't
 *  scroll), so the cards are a fixed size and never reflow as descriptions stream
 *  in — everything stays within the viewport above the footer CTA. */
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 1fr;
  gap: 20px;
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
`;

/** "UPLOAD YOUR OWN LOGO" eyebrow (manual mode). */
export const ManualLabel = styled(Text)`
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${CUST.textMuted};
`;

export const Specs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

/** Manual-upload failure message (unsupported file / processing error). */
export const UploadError = styled(Text)`
  font-size: 13px;
  line-height: 1.5;
  color: ${CUST.required};
`;

export const SpecLine = styled(Text)`
  font-size: 13px;
  line-height: 1.5;
  color: ${CUST.textFaint};
`;

/** "Upload another logo" / "Choose from generated logos" plain links. */
export const LinkBtn = styled.button`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  border: none;
  background: transparent;
  color: ${CUST.accentText};
  cursor: pointer;
`;

export const LinkLabel = styled(Text)`
  font-size: 14px;
  color: ${CUST.accentText};
  white-space: nowrap;
`;

export const ModeToggle = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 0;
  border: none;
  background: transparent;
  color: ${CUST.textMuted};
  cursor: pointer;
  transition: filter ${CUST_ANIM.INTERACT_MS}ms ease;

  &:hover {
    filter: brightness(1.25);
  }
`;

export const ModeToggleLabel = styled(Text)`
  font-size: 14px;
  line-height: 20px;
  color: ${CUST.textMuted};
  white-space: nowrap;
`;

/* ── Mobile ──────────────────────────────────────────────────────────────── */

export const MobileBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  width: 100%;
`;

export const MobileHeading = styled(Text)`
  margin-top: 4px;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.1;
  text-align: center;
  background-image: ${CUST_GRADIENTS.headingGradient};
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
`;

export const MobileRefresh = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: none;
  background: transparent;
  color: ${CUST.accentText};
  cursor: pointer;
`;

export const MobileRefreshLabel = styled(Text)`
  font-size: 13.5px;
  line-height: 18px;
  color: ${CUST.accentText};
`;

export const MobileList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-top: 4px;
`;

export const MobileSuccess = styled(Text)`
  margin-top: 4px;
  font-size: 16px;
  font-weight: 800;
  text-align: center;
  color: ${CUST.uploadSuccess};
`;

export const MobileSuccessBody = styled(Text)`
  max-width: 320px;
  font-size: 13px;
  line-height: 1.4;
  text-align: center;
  color: ${CUST.textMuted};
`;